module.exports = __webpack_public_path__ + "static/img/灰背景.396494d4.png";